import {WriteUs} from './write-us';

export class WriteUsRequest {
    data: WriteUs;

    constructor(category: WriteUs) {
        this.data = category;
    }
}
